// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Abschnitte der Produktseite: jeder Abschnitt ein Band über die ganze Breite */
.product-section {
  position: relative;
  padding-block: 2.25rem 2.75rem;
  --band: var(--bg-primary);
  --note-ground: var(--band);
  background: var(--band);
  box-shadow: 0 0 0 100vmax var(--band);
  clip-path: inset(0 -100vmax);
}

.product-section.band-none:first-child {
  padding-top: 0.5rem;
}

.product-section.band-a { --band: var(--band-a); }
.product-section.band-b { --band: var(--band-b); }
.product-section.band-c { --band: var(--band-c); }

/* Kaufen: warmes Band mit farbiger Kante oben (zweiter Schatten, über die ganze Breite) */
.product-section.band-buy {
  --band: var(--band-buy);
  clip-path: inset(-4px -100vmax -4px);
  margin-block: 4px;
}

/* kräftige kupferne Kante oben und unten über die ganze Breite (border-image ragt nur sichtbar hinaus) */
.product-section.band-buy::before,
.product-section.band-buy::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 4px;
  border-image: linear-gradient(var(--neon-buy), var(--neon-buy)) fill 0 / / 0 100vmax;
  pointer-events: none;
}

.product-section.band-buy::before {
  top: -4px;
}

.product-section.band-buy::after {
  bottom: -4px;
}

.product-section-title {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  margin: 0 0 1.5rem;
}

.section-title-icon {
  width: 3.2rem;
  height: 3.2rem;
}

.product-tab-intro,
p.product-tab-intro {
  margin: 0 0 1rem;
  color: var(--text-secondary);
}

/* Überblick */
.product-overview {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.5rem 3.5rem;
}

.product-overview-main,
.product-overview-side {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-content: start;
  gap: 0.75rem;
  min-width: 0;
}

.product-overview-main {
  max-width: 48rem;
}

.product-overview-side .note {
  margin-top: 0.6rem;
}

.product-overview-side .device-check:first-child {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}

@media (min-width: 1000px) {
  .product-overview {
    grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  }
}

.product-description {
  margin: 0;
  font-size: 1.08rem;
  color: var(--text-primary);
}

.product-overview h3 {
  margin: 1rem 0 0;
}

.product-features {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--border-primary);
}

.product-features li {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid var(--border-primary);
  color: var(--text-primary);
}

.product-features .feature-icon {
  width: 2.6rem;
  height: 2.6rem;
  --frame-tick: 7px;
}

/* Geräteprüfung */
.device-check {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.6rem;
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--border-primary);
}

.device-check h3 {
  margin: 0;
}

.device-check-mine {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-weight: 700;
}

.device-check-mine.ok,
.device-check-results li.ok {
  color: var(--success);
}

.device-check-mine.no,
.device-check-results li.no {
  color: var(--signal);
}

.device-check .device-search {
  max-width: 24rem;
}

.device-check-results {
  list-style: none;
  margin: 0;
  padding: 0;
  max-width: 32rem;
}

.device-check-results li {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0;
  border-bottom: 1px solid var(--border-primary);
}

.device-check-results li span:nth-child(2) {
  color: var(--text-primary);
}

.device-check-state {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.device-check-all summary {
  cursor: pointer;
  padding: 0.5rem 0;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent-primary);
}

.device-check-list {
  columns: 14rem auto;
  column-gap: 1.5rem;
  margin: 0.25rem 0 0;
  padding: 0;
  list-style: none;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.device-check-list li {
  break-inside: avoid;
  padding: 0.15rem 0;
}

/* Inhalts-Tabs (Bedienung, App-Anleitung …) */
.product-content-tab {
  max-width: 100%;
}

.product-content-tab > .product-tab-intro {
  max-width: 48rem;
}

/* Abschnitte als Kacheln nebeneinander */
.content-tab-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 27rem), 1fr));
  border-top: 1px solid var(--border-primary);
  border-left: 1px solid var(--border-primary);
}

.content-tab-grid > .product-tab-section {
  min-width: 0;
  padding: 1.1rem 1.2rem 1rem;
  border-right: 1px solid var(--border-primary);
  border-bottom: 1px solid var(--border-primary);
}

.content-tab-grid > .product-tab-section + .product-tab-section {
  margin-top: 0;
}

.content-tab-grid .product-tab-section h3 {
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
}

.content-tab-grid .product-tab-section p {
  font-size: 0.97rem;
}

/* Legende: Wert links, Bedeutung rechts, kompakt */
.legend-list {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0.35rem 0.9rem;
  margin: 0.5rem 0 0.25rem;
  font-size: 0.93rem;
}

.legend-list > div {
  display: contents;
}

.legend-list dt {
  font-family: var(--font-mono);
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
  max-width: 12rem;
  overflow-wrap: break-word;
}

.legend-list dd {
  margin: 0;
  color: var(--text-secondary);
}

.legend-list dd p {
  margin: 0;
  color: var(--text-secondary);
}

.product-content-tab > h2 {
  display: none;
}

.product-tab-section + .product-tab-section {
  margin-top: 1.75rem;
}

.product-tab-section > :last-child {
  margin-bottom: 0;
}

.product-tab-section h3 {
  margin: 0 0 0.6rem;
}

.product-tab-figure {
  margin: 0.25rem 0 0.9rem;
  max-width: 22rem;
}

.product-tab-figure img {
  display: block;
  width: 100%;
  height: auto;
  border: 1px solid var(--border-primary);
  background: #050808;
}

.product-tab-section p {
  color: var(--text-primary);
}

/* Aufzählung mit Strich als Marke */
.product-tab-list {
  margin: 0.4rem 0 0.9rem;
  padding: 0;
  list-style: none;
}

.product-tab-list li {
  position: relative;
  padding-left: 1.1rem;
  margin: 0.35rem 0;
  font-size: 0.97rem;
}

.product-tab-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.68em;
  width: 0.55rem;
  border-top: 2px solid var(--accent-primary);
}

.product-guides-all {
  margin: 1.5rem 0 0;
}

@media (max-width: 560px) {
  .legend-list {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.1rem;
  }

  .legend-list dd {
    margin-bottom: 0.5rem;
  }
}

.product-datafields-link {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  justify-self: start;
  font-family: var(--font-mono);
  font-size: 0.76rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

/* Kaufen-Tab und -Titel ebenfalls in Neon */
:root .section-tabs-prominent .section-tab[data-tab='buy'] {
  --tab-tone: var(--neon-buy);
  color: var(--text-primary);
}

.section-tab[data-tab='buy'] .guide-icon,
.band-buy .section-title-icon .guide-icon {
  --ink: var(--neon-buy) !important;
  --ac: var(--neon-buy) !important;
}

:root .product-section.band-buy .section-title-icon.icon-tile.frame {
  background: color-mix(in srgb, var(--neon-buy) 18%, var(--bg-secondary));
  border-color: var(--neon-buy);
  --frame-color: var(--neon-buy);
}
`, "",{"version":3,"sources":["webpack://./src/components/DetailTabs/DetailTabs.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,qBAAqB,EAAE;;AAEjD,0FAA0F;AAC1F;EACE,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA,yGAAyG;AACzG;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oFAAoF;EACpF,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,uEAAuE;EACvE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;EAEE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,wEAAwE;EACxE,6BAA6B;EAC7B,8BAA8B;AAChC","sourcesContent":["/* Abschnitte der Produktseite: jeder Abschnitt ein Band über die ganze Breite */\n.product-section {\n  position: relative;\n  padding-block: 2.25rem 2.75rem;\n  --band: var(--bg-primary);\n  --note-ground: var(--band);\n  background: var(--band);\n  box-shadow: 0 0 0 100vmax var(--band);\n  clip-path: inset(0 -100vmax);\n}\n\n.product-section.band-none:first-child {\n  padding-top: 0.5rem;\n}\n\n.product-section.band-a { --band: var(--band-a); }\n.product-section.band-b { --band: var(--band-b); }\n.product-section.band-c { --band: var(--band-c); }\n\n/* Kaufen: warmes Band mit farbiger Kante oben (zweiter Schatten, über die ganze Breite) */\n.product-section.band-buy {\n  --band: var(--band-buy);\n  clip-path: inset(-4px -100vmax -4px);\n  margin-block: 4px;\n}\n\n/* kräftige kupferne Kante oben und unten über die ganze Breite (border-image ragt nur sichtbar hinaus) */\n.product-section.band-buy::before,\n.product-section.band-buy::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 4px;\n  border-image: linear-gradient(var(--neon-buy), var(--neon-buy)) fill 0 / / 0 100vmax;\n  pointer-events: none;\n}\n\n.product-section.band-buy::before {\n  top: -4px;\n}\n\n.product-section.band-buy::after {\n  bottom: -4px;\n}\n\n.product-section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  margin: 0 0 1.5rem;\n}\n\n.section-title-icon {\n  width: 3.2rem;\n  height: 3.2rem;\n}\n\n.product-tab-intro,\np.product-tab-intro {\n  margin: 0 0 1rem;\n  color: var(--text-secondary);\n}\n\n/* Überblick */\n.product-overview {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 1.5rem 3.5rem;\n}\n\n.product-overview-main,\n.product-overview-side {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  align-content: start;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.product-overview-main {\n  max-width: 48rem;\n}\n\n.product-overview-side .note {\n  margin-top: 0.6rem;\n}\n\n.product-overview-side .device-check:first-child {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: 0;\n}\n\n@media (min-width: 1000px) {\n  .product-overview {\n    grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);\n  }\n}\n\n.product-description {\n  margin: 0;\n  font-size: 1.08rem;\n  color: var(--text-primary);\n}\n\n.product-overview h3 {\n  margin: 1rem 0 0;\n}\n\n.product-features {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid var(--border-primary);\n}\n\n.product-features li {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  padding: 0.55rem 0;\n  border-bottom: 1px solid var(--border-primary);\n  color: var(--text-primary);\n}\n\n.product-features .feature-icon {\n  width: 2.6rem;\n  height: 2.6rem;\n  --frame-tick: 7px;\n}\n\n/* Geräteprüfung */\n.device-check {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.6rem;\n  margin-top: 1.25rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--border-primary);\n}\n\n.device-check h3 {\n  margin: 0;\n}\n\n.device-check-mine {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  font-weight: 700;\n}\n\n.device-check-mine.ok,\n.device-check-results li.ok {\n  color: var(--success);\n}\n\n.device-check-mine.no,\n.device-check-results li.no {\n  color: var(--signal);\n}\n\n.device-check .device-search {\n  max-width: 24rem;\n}\n\n.device-check-results {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-width: 32rem;\n}\n\n.device-check-results li {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 0;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.device-check-results li span:nth-child(2) {\n  color: var(--text-primary);\n}\n\n.device-check-state {\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.device-check-all summary {\n  cursor: pointer;\n  padding: 0.5rem 0;\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--accent-primary);\n}\n\n.device-check-list {\n  columns: 14rem auto;\n  column-gap: 1.5rem;\n  margin: 0.25rem 0 0;\n  padding: 0;\n  list-style: none;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.device-check-list li {\n  break-inside: avoid;\n  padding: 0.15rem 0;\n}\n\n/* Inhalts-Tabs (Bedienung, App-Anleitung …) */\n.product-content-tab {\n  max-width: 100%;\n}\n\n.product-content-tab > .product-tab-intro {\n  max-width: 48rem;\n}\n\n/* Abschnitte als Kacheln nebeneinander */\n.content-tab-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 27rem), 1fr));\n  border-top: 1px solid var(--border-primary);\n  border-left: 1px solid var(--border-primary);\n}\n\n.content-tab-grid > .product-tab-section {\n  min-width: 0;\n  padding: 1.1rem 1.2rem 1rem;\n  border-right: 1px solid var(--border-primary);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.content-tab-grid > .product-tab-section + .product-tab-section {\n  margin-top: 0;\n}\n\n.content-tab-grid .product-tab-section h3 {\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.content-tab-grid .product-tab-section p {\n  font-size: 0.97rem;\n}\n\n/* Legende: Wert links, Bedeutung rechts, kompakt */\n.legend-list {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 0.35rem 0.9rem;\n  margin: 0.5rem 0 0.25rem;\n  font-size: 0.93rem;\n}\n\n.legend-list > div {\n  display: contents;\n}\n\n.legend-list dt {\n  font-family: var(--font-mono);\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  max-width: 12rem;\n  overflow-wrap: break-word;\n}\n\n.legend-list dd {\n  margin: 0;\n  color: var(--text-secondary);\n}\n\n.legend-list dd p {\n  margin: 0;\n  color: var(--text-secondary);\n}\n\n.product-content-tab > h2 {\n  display: none;\n}\n\n.product-tab-section + .product-tab-section {\n  margin-top: 1.75rem;\n}\n\n.product-tab-section > :last-child {\n  margin-bottom: 0;\n}\n\n.product-tab-section h3 {\n  margin: 0 0 0.6rem;\n}\n\n.product-tab-figure {\n  margin: 0.25rem 0 0.9rem;\n  max-width: 22rem;\n}\n\n.product-tab-figure img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border: 1px solid var(--border-primary);\n  background: #050808;\n}\n\n.product-tab-section p {\n  color: var(--text-primary);\n}\n\n/* Aufzählung mit Strich als Marke */\n.product-tab-list {\n  margin: 0.4rem 0 0.9rem;\n  padding: 0;\n  list-style: none;\n}\n\n.product-tab-list li {\n  position: relative;\n  padding-left: 1.1rem;\n  margin: 0.35rem 0;\n  font-size: 0.97rem;\n}\n\n.product-tab-list li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0.68em;\n  width: 0.55rem;\n  border-top: 2px solid var(--accent-primary);\n}\n\n.product-guides-all {\n  margin: 1.5rem 0 0;\n}\n\n@media (max-width: 560px) {\n  .legend-list {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 0.1rem;\n  }\n\n  .legend-list dd {\n    margin-bottom: 0.5rem;\n  }\n}\n\n.product-datafields-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  justify-self: start;\n  font-family: var(--font-mono);\n  font-size: 0.76rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n/* Kaufen-Tab und -Titel ebenfalls in Neon */\n:root .section-tabs-prominent .section-tab[data-tab='buy'] {\n  --tab-tone: var(--neon-buy);\n  color: var(--text-primary);\n}\n\n.section-tab[data-tab='buy'] .guide-icon,\n.band-buy .section-title-icon .guide-icon {\n  --ink: var(--neon-buy) !important;\n  --ac: var(--neon-buy) !important;\n}\n\n:root .product-section.band-buy .section-title-icon.icon-tile.frame {\n  background: color-mix(in srgb, var(--neon-buy) 18%, var(--bg-secondary));\n  border-color: var(--neon-buy);\n  --frame-color: var(--neon-buy);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
